import { render, staticRenderFns } from "./addDataPrivilegeUnit.vue?vue&type=template&id=186b4986&scoped=true"
import script from "./addDataPrivilegeUnit.vue?vue&type=script&lang=js"
export * from "./addDataPrivilegeUnit.vue?vue&type=script&lang=js"
import style0 from "./addDataPrivilegeUnit.vue?vue&type=style&index=0&id=186b4986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b4986",
  null
  
)

export default component.exports